/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';
var isBoolean = function (value) {
  return isType(value, 'Boolean');
};
export default isBoolean;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-boolean.js
// module id = 86
// module chunks = 0